import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateTaskEstateFormTemplateStatus extends Enum {
  key!: string;
  value!: string;
  color!: string;

  static IN_PROGRESS: EstateTaskEstateFormTemplateStatus = {
    key: 'in_progress',
    get value(): string {
      return Lang.t('estatetask.in-progress');
    },
    color: '#7E84A3'
  };

  static SENT_FOR_REVIEW: EstateTaskEstateFormTemplateStatus = {
    key: 'sent_for_review',
    get value(): string {
      return Lang.t('estatetask.sent-for-review');
    },
    color: '#EE964B'
  };

  static APPROVED: EstateTaskEstateFormTemplateStatus = {
    key: 'approved',
    get value(): string {
      return Lang.t('estatetask.approved');
    },
    color: '#61D098'
  };

  static REJECTED: EstateTaskEstateFormTemplateStatus = {
    key: 'rejected',
    get value(): string {
      return Lang.t('creditorclaim.rejected');
    },
    color: '#F97068'
  };

  static TODO: EstateTaskEstateFormTemplateStatus = {
    key: 'todo',
    get value(): string {
      return Lang.t('estate.to-do');
    },
    color: '#7E84A3'
  };

  static SUBMITTED: EstateTaskEstateFormTemplateStatus = {
    key: 'submitted',
    get value(): string {
      return Lang.t('guidancestep.submitted');
    },
    color: '#60C49D'
  };

  static NOT_REQURIED: EstateTaskEstateFormTemplateStatus = {
    key: 'not_required',
    get value(): string {
      return Lang.t('guidancestep.not-required');
    },
    color: '#F97068'
  };
}
